import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3">
					Kiam en griza decembra mateno la Suno, foje aperante elsur nuboj, tamen iom prilumas la Teron, 
					el mia gorĝo nevole forŝiriĝas la krio: «Ĉu por ĉiuj? Senpage??
				</p>
				
				<p class="mb-3">
					La Suno aperas ĉiumatene; ĉiumatene estas lumo; sed ĉu vere neniu rajtas forŝalti ĝin? 
					Ĉu neniu ĝin dozos por ni, jen igante senmoviĝi, kiam lumo forestas, 
					jen permesante tre-tre vigle faradi ĉion bezonatan dum lumas? 
					Ĉu ne havos sunlumo la mastron, kiu per butonpremo aktivigos kaj malaktivigos nin, kvazaŭ konektitajn al la reto aparatetojn? 
				</p>
				
				<p class="mb-3">
					Ĉu vere ja tio estas permesata – doni lumon por ĉiuj senpage?!?
				</p>
				
				<p class="mb-3">
					Ĉu povas okazi tiel en la mondo??»
				</p>
				
				<p class="mb-3">
					Tiel krias mi; kaj dume la malserenan tagon rapide forlasas lumo. 
					Ĝis la kvara horo jam densiĝas tenebro. 
				</p>
				
				<p class="mb-3">
					Kaj en mallumo ni obeeme atendas, kiam oni enŝaltos elektron.
				</p>
			</div>
    `
  )
}

const itemName = {
  esp: 'Vintre de 2022'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 